const isEmptyArray = (value: any): boolean => {
  if (Array.isArray(value)) {
    return value.length === 0
  }
  return false
}

export default isEmptyArray
